import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { OverviewHeaderIntroRow } from "../../../partial-templates/overview-header/overview-header.stories";
import { addI18nTranslations } from "../../../../utils";
import { renderPageTemplate } from "../../../../utils";

export default {
    title: "MyTrumpf/Page Templates/My Software/Overview",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
};

const Template = () => {
    addI18nTranslations({
        namespace: "my-software",
        language: "de-DE",
        translations: {
            filter: {
                favorites: {
                    label: "Favorites Only (translated)",
                },
                downloads: {
                    label: "With Downloads (translated)",
                },
                options: {
                    label: "With Options (translated)",
                },
                serviceagreements: {
                    label: "With Service Agreements (translated)",
                },
            },
            content: {
                isFav: {
                    column: "Fav",
                },
                name: {
                    column: "Produktname",
                },
                latestAvailableVersion: {
                    column: "Neueste verfügbare Version",
                    update: "Update",
                },
                serviceAgreementStatus: {
                    column: "Servicevereinbarung",
                    values: {
                        SERVICE_AGREEMENT_Inactive:
                            "keine aktive Servicevereinbarung",
                        SERVICE_AGREEMENT_Active: "Aktiv",
                    },
                },
                detailLink: {
                    column: "Details",
                },
            },
        },
    });

    return html`
        <div class="ux-t-container">
            ${OverviewHeaderIntroRow({
                type: "my-software",
                headline: "My Software",
                buttonLabel: "To Downloads",
            })}
            <ux-sidebar
                name="filter-sidebar-1"
                close-on-esc-key="true"
                close-on-backdrop-click="true"
                transition="slide"
                alignment="right"
                disable-backdrop="false"
                disable-close-icon="false"
                align-header="false"
                align-footer="false"
                opened="false"
            >
                <ux-sidebar-content class="ux-u-pb-xs ux-u-px-xs">
                    <ux-iws-stateful-filter
                        url="generated-mock-data/mysoftware-filter.json"
                        scope="my-software"
                        filter-column-class="ux-col-12 ux-u-mb-xs"
                        disable-tags
                    ></ux-iws-stateful-filter>
                </ux-sidebar-content>
                <ux-sidebar-footer>
                    <ux-button
                        class="ux-u-mb-xxs"
                        variant="primary"
                        class="ux-button--full-width"
                        data-trigger-sidebar="toggle,filter-sidebar-1"
                        >Treffer anzeigen</ux-button
                    >
                    <ux-iws-stateful-filter-remove-button
                        variant="secondary"
                        scope="my-software"
                    ></ux-iws-stateful-filter-remove-button>
                </ux-sidebar-footer>
            </ux-sidebar>
        </div>
        <div class="ux-t-container-full">
            <div class="ux-row u-background-blue-gradient ux-u-shadow-inset">
                <div class="ux-col-10 ux-u-offset-1 ux-u-mt-xs">
                    <ux-iws-stateful-filter-button
                        scope="my-software"
                        data-trigger-sidebar="toggle,filter-sidebar-1"
                        >Filter</ux-iws-stateful-filter-button
                    >
                    <ux-iws-stateful-filter-tags
                        scope="my-software"
                    ></ux-iws-stateful-filter-tags>
                </div>
                <ux-iws-stateful-overview
                    url="generated-mock-data/mysoftware.json"
                    scope="my-software"
                    debug="true"
                    switch="true"
                    view="tiles"
                >
                </ux-iws-stateful-overview>
            </div>
        </div>
    `;
};

const Empty = () => html`
    <div class="ux-t-container">
        ${OverviewHeaderIntroRow({
            type: "my-software",
            headline: "My Software",
            buttonLabel: "To Downloads",
        })}
    </div>
    <div class="ux-t-container-full">
        <div class="ux-row u-background-blue-gradient ux-u-shadow-inset">
            <ux-iws-stateful-overview
                url="generated-mock-data/mysoftware-empty.json"
                scope="my-software"
                switch="false"
            >
            </ux-iws-stateful-overview>
        </div>
    </div>
`;

export const Default = () => renderPageTemplate(() => Template());

export const NoResults = () => renderPageTemplate(() => Empty());
